import SnackNotificationsContextProvider from "../../contexts/snack-notifications/SnackNotificationsContext";
import {Navigate, Route, Routes} from "react-router";
import {Suspense, useMemo, useState} from "react";
import BackdropSpinner from "../shared/backdrop-spinner/BackdropSpinner";
import useAppRoutes from "./useAppRoutes";
import Navigation from "../navigation/Navigation";
import ToolbarContext from "../../contexts/toolbar-context/ToolbarContext";
import {DASHBOARD} from "../../constants/routes";
import {LogoProvider} from "../../contexts/logo-context/LogoContext";
import PopupNotificationPoller from "./PopupNotificationPoller";

function App() {
    const {routes} = useAppRoutes();
    const [toolbarText, setToolbarText] = useState('');

    const toolbarContextValue = useMemo(() => (
        {
            toolbarText,
            setToolbarText,
        }
    ), [toolbarText]);

    return (
        <SnackNotificationsContextProvider>
            <LogoProvider>
                <PopupNotificationPoller />
                <ToolbarContext.Provider value={toolbarContextValue}>
                    <Navigation>
                    <Routes>
                        {routes.map(({
                                         component,
                                         canSeeRoute,
                                         redirectTo,
                                         ...r
                                     }) => (
                            <Route
                                {...r}
                                key={r.path}
                                element={
                                    canSeeRoute ? (
                                        <Suspense fallback={<BackdropSpinner/>}>
                                            {component}
                                        </Suspense>
                                    ) : <Navigate to={redirectTo} replace/>
                                }
                            />
                        ))}
                        <Route
                            path="*"
                            element={<Navigate to={DASHBOARD} replace/>}
                        />
                    </Routes>
                </Navigation>
                </ToolbarContext.Provider>
            </LogoProvider>
        </SnackNotificationsContextProvider>
    );
}

export default App;
